import { isObject, type MaterialColour, useApiMaterialsV1MaterialColoursRetrieve } from 'api';
import { capitalizeString } from 'ui';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export const MaterialColourAutocomplete = (props: Omit<AutocompleteFieldProps<MaterialColour>, 'options'>) => {
  const { data, isLoading } = useApiMaterialsV1MaterialColoursRetrieve();

  return (
    <AutocompleteField<MaterialColour>
      data-testid="material-colour-autocomplete"
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(item) => {
        if (isObject(item) && item?.name) {
          return capitalizeString(item.name);
        }
        return '';
      }}
      valueField="id"
      filterOptions={(options, state) =>
        options.filter((option) => option.name.toLowerCase().includes(state.inputValue.toLowerCase()))
      }
      {...props}
    />
  );
};
